var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagCocosIsland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.561 22.9565L25.0001 23.8746L25.9916 23.6455L25.5476 24.5612L26.3449 25.1934L25.3521 25.4172L25.355 26.4349L24.561 25.7982L23.7671 26.4349L23.7699 25.4172L22.7772 25.1934L23.5745 24.5612L23.1305 23.6455L24.122 23.8746L24.561 22.9565Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4762 13.2175L20.9153 14.1356L21.9068 13.9064L21.4628 14.8222L22.2601 15.4544L21.2674 15.6782L21.2701 16.6958L20.4762 16.0592L19.6823 16.6958L19.685 15.6782L18.6924 15.4544L19.4897 14.8222L19.0456 13.9064L20.0372 14.1356L20.4762 13.2175Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.561 7.65234L25.0001 8.57041L25.9916 8.34116L25.5476 9.25691L26.3449 9.88922L25.3521 10.1129L25.3548 11.1306L24.561 10.4939L23.7671 11.1306L23.7699 10.1129L22.7773 9.88922L23.5745 9.25691L23.1305 8.34116L24.122 8.57041L24.561 7.65234Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1287 11.8262L28.5678 12.7442L29.5593 12.515L29.1153 13.4308L29.9126 14.063L28.9199 14.2868L28.9226 15.3045L28.1287 14.6678L27.3348 15.3045L27.3375 14.2868L26.3449 14.063L27.1422 13.4308L26.6981 12.515L27.6896 12.7442L28.1287 11.8262Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5771 16.6958L25.9226 17.7587H27.0401L26.1359 18.4156L26.4814 19.4784L25.5771 18.8216L24.6731 19.4784L25.0184 18.4156L24.1143 17.7587H25.2318L25.5771 16.6958Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7389 20.5218C15.2416 20.5218 13.2171 18.4973 13.2171 16.0001C13.2171 13.5028 15.2416 11.4783 17.7389 11.4783C18.5176 11.4783 19.2503 11.6753 19.8899 12.0218C18.8864 11.0404 17.5143 10.4348 15.9997 10.4348C12.9262 10.4348 10.4346 12.9264 10.4346 16C10.4346 19.0736 12.9262 21.5652 15.9997 21.5652C17.5142 21.5652 18.8864 20.9596 19.8898 19.9782C19.2503 20.3249 18.5176 20.5218 17.7389 20.5218Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0611 6.26094C9.57989 5.42944 8.68145 4.86963 7.6517 4.86963C6.62195 4.86963 5.72351 5.42944 5.24226 6.26094H10.0611Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0704 6.2771L7.6517 8.69579L5.23302 6.2771C5.00183 6.68279 4.86914 7.15197 4.86914 7.65235C4.86914 9.18916 6.11495 10.435 7.65177 10.435C9.18858 10.435 10.4344 9.18922 10.4344 7.65235C10.4343 7.15197 10.3016 6.68279 10.0704 6.2771Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95605 8V10.3471C7.17837 10.4043 7.41149 10.4347 7.65168 10.4347C7.89187 10.4347 8.12499 10.4043 8.3473 10.3471V8H6.95605Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCocosIsland);
export default __webpack_public_path__ + "static/media/flag_cocos_island.a0f10432c2c8a2a125131d6faa727350.svg";
export { ForwardRef as ReactComponent };